import { render, staticRenderFns } from "./ProfileCompany.vue?vue&type=template&id=2bf5356e&scoped=true"
import script from "./ProfileCompany.vue?vue&type=script&lang=js"
export * from "./ProfileCompany.vue?vue&type=script&lang=js"
import style0 from "./ProfileCompany.vue?vue&type=style&index=0&id=2bf5356e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5356e",
  null
  
)

export default component.exports